/**
 * abilityVfxVolleyArrow — Ashe W Volley ice missile mesh (SP-02).
 */
export function buildVolleyArrow(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.9 * (spec.scale || 1);
  const shaftMat = mat(THREE, spec.color || 0x7dd3fc, 0.95);
  const crystalMat = mat(THREE, 0xbae6fd, 0.92);

  const shaft = new THREE.Mesh(
    new THREE.CylinderGeometry(0.035 * s, 0.035 * s, 1.15 * s, 8).rotateX(Math.PI / 2),
    shaftMat
  );
  group.add(shaft);

  const tip = new THREE.Mesh(
    new THREE.ConeGeometry(0.11 * s, 0.38 * s, 6).rotateX(Math.PI / 2),
    crystalMat
  );
  tip.position.z = 0.58 * s;
  group.add(tip);

  for (let i = 0; i < 2; i += 1) {
    const fin = new THREE.Mesh(
      new THREE.BoxGeometry(0.06 * s, 0.02 * s, 0.28 * s),
      crystalMat
    );
    fin.position.set((i === 0 ? -1 : 1) * 0.08 * s, 0, -0.45 * s);
    group.add(fin);
  }

  const trail = new THREE.Mesh(
    new THREE.SphereGeometry(0.07 * s, 6, 6),
    mat(THREE, spec.color || 0x7dd3fc, 0.55)
  );
  trail.position.z = -0.55 * s;
  group.add(trail);

  group.userData = { shape: 'volley_arrow' };
  return group;
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
